import {
  alpha,
  Backdrop,
  CircularProgress,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material'

type TProps = {
  show: boolean
  sx?: SxProps<Theme>
  isTransparent?: boolean
}

function LoadingWithBackdrop({ show, sx = {}, isTransparent = false }: TProps) {
  const theme = useTheme()
  const opacity = isTransparent ? 0.3 : 1

  return (
    <Backdrop
      className="loading-backdrop"
      sx={{
        background: alpha(theme.palette.mainBackground, opacity),
        color: theme.palette.secondary1,
        zIndex: theme.zIndex.tooltip + 1,
        transition: 'opacity 0.3s ease, visibility 0.3s ease',
        opacity: show ? 1 : 0,
        visibility: show ? 'visible' : 'hidden',
        '&.loading-backdrop': {
          marginTop: 0,
        },
        ...sx,
      }}
      open={show}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  )
}
export default LoadingWithBackdrop
